<script>
// Extensions
import View from "@/views/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "EmploymentAgency",

  metaInfo: { title: "Employment Agency Contract Management System" },

  extends: View,

  mixins: [
    LoadSections(["hero-alt", "employment-agency", "theme-features-3", "info"])
  ],

  props: {
    id: {
      type: String,
      default: "Employment Agency"
    }
  }
};
</script>
